module.exports = __webpack_public_path__ + "media/tiger_win.e0880e28.mp3";